module.exports = (pageId, preview) => `query {
  page(id: "${pageId}",preview: ${preview}) {
    contentCollection {
      items {
        __typename
      }
    }
  }
}`;
